import app from "@/app";
import "@/lang/index";
import "@/pages/index";
import "@/settings/fv";
import "@/utils/directives";
import "@/utils/filters";
import "@/oweb.custom";
import "@/oweb.components";
import launcher from "@/utils/launcher";
import { scriptLoader } from 'oweb';

const src = app.configs.get('OW_APP_UPDATER_SCRIPT_SRC');

if (src) {
	scriptLoader.tryLoad(src, undefined, undefined, true)
}

launcher(app).launch();
